// extracted by mini-css-extract-plugin
export default {"overlay":"BottomPage_overlay__3mHTj","sheet":"BottomPage_sheet__as3Bo","slideUp":"BottomPage_slideUp__5XYMx","handle":"BottomPage_handle__xcBRo"};